<template>
  <div class="malus-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$I = I₀ · cos²(θ)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>检偏器角度 θ</label>
            <span class="val">{{ theta.toFixed(1) }}°</span>
          </div>
          <div class="hud-item orange">
            <label>透射率 I/I₀</label>
            <span class="val">{{ (intensityRatio * 100).toFixed(1) }} %</span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 450 240" preserveAspectRatio="xMidYMid meet">
          <!-- 极坐标光强分布图 (Polar Distribution Plot) -->
          <g transform="translate(320, 120)">
             <circle r="60" fill="none" stroke="#334155" stroke-dasharray="2,2" />
             <path :d="polarPath" fill="rgba(14, 165, 233, 0.2)" stroke="#0ea5e9" stroke-width="2" />
             <line x1="0" y1="0" :x2="60 * Math.cos(rad)" :y2="-60 * Math.sin(rad)" stroke="#fbbf24" stroke-width="2" />
          </g>

          <!-- 偏振片演示 (Polarizers) -->
          <g transform="translate(60, 120)">
             <circle r="40" fill="rgba(30, 41, 59, 0.8)" stroke="#94a3b8" />
             <line x1="0" y1="-35" x2="0" y2="35" stroke="#fbbf24" stroke-width="3" />
             <text y="55" text-anchor="middle" fill="#64748b" font-size="9">起偏器 (固定)</text>
          </g>

          <!-- 旋转检偏器 (Rotating Analyzer) -->
          <g :transform="`translate(180, 120) rotate(${-theta})`">
             <circle r="42" fill="rgba(30, 41, 59, 0.5)" stroke="#fbbf24" stroke-width="2" />
             <line x1="0" y1="-38" x2="0" y2="38" stroke="#f43f5e" stroke-width="4" />
          </g>
          <text x="180" y="175" text-anchor="middle" fill="#64748b" font-size="9">检偏器 (旋转)</text>

          <!-- 穿透后的光矢量 (Transmitted Vector) -->
          <line x1="250" y1="120" x2="350" y2="120" stroke="#0ea5e9" :stroke-width="intensityRatio * 15 + 1" opacity="0.4" />
        </svg>

        <div class="physics-caption">
           规律：当两个偏振片的透振方向平行时光最强，垂直时完全消光。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="flex-row items-center gap-6">
              <div class="flex-1">
                 <label class="s-label">旋转检偏器角度 (θ)：{{ theta.toFixed(1) }}°</label>
                 <el-slider v-model="theta" :min="0" :max="180" size="small"></el-slider>
              </div>
              <div class="btn-group">
                 <el-button type="info" size="mini" @click="theta = 90">正交消光点</el-button>
                 <el-button size="mini" @click="theta = 0">全透光点</el-button>
              </div>
           </div>
        </div>
        
        <!-- 高对比度蓝色专业卡片加固 -->
        <div class="discovery-card-discovery-tir" v-latex>
           <div class="icon-wrap"><i class="el-icon-refresh"></i></div>
           <div class="text-content">
             <p><strong>实战物理/隔热贴膜：</strong>马吕斯定律揭示了横波的方向性。<strong>解惑：</strong>为什么两层贴膜转一下就变黑？<strong>观察：</strong>调节滑块。你会发现光强的消长不是线性的，而是遵循“余弦平方”规律。这就导致在 $90°$ 时光会被完全杀灭。这一原理是**液晶显示器 (LCD)** 精确控制亮度的核心逻辑。
             </p>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'PolarizationMalusProViz',
  data() {
    return {
      theta: 45
    }
  },
  computed: {
    rad() { return this.theta * Math.PI / 180; },
    intensityRatio() { return Math.pow(Math.cos(this.rad), 2); },
    polarPath() {
       let p = "M 0,0 ";
       for(let a=0; a<=360; a+=2) {
          const r_rad = a * Math.PI / 180;
          const r = 60 * Math.pow(Math.cos(r_rad), 2);
          p += `L ${r * Math.cos(r_rad)},${-r * Math.sin(r_rad)} `;
       }
       return p + " Z";
    }
  }
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.malus-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
